<app-data-table
	*ngIf="loadComplete"
	[(dataObject)]="employeeList"
	[(tableDataModel)]="tableModel"
	(dataTableRowOnClickChange)="rowSelect($event)"
></app-data-table>
